export default __webpack_public_path__ + "69ff00e.woff2";